export default function toggleArray(array, item) {
  return array.includes(item)
    ? array.filter((i) => i !== item)
    : [...array, item];
}
